module.exports = __webpack_public_path__ + "img/40_38_071_570.d4dd7c65.jpg";